<template>
  <ListeReferentiel
    ref="liste"
    titre="Types de chambre"
    icone="bi-door-open"
    ressource="type_chambres"
    tri-defaut="tch.nom"
    :options-tri="{ Nom: 'tch.nom', 'Tarif journalier': 'tch.tarifParJour', 'Date de création': 'tch.createdAt', Statut: 'tch.isEnabled' }"
    placeholder="Nom ou description…"
    unite="type(s)"
    vide="Aucun type de chambre enregistré."
    :colonnes="6"
    :peut-creer="$store.getters.hasPermission('CONFIG_CREER_TYPE_CHAMBRE')"
    libelle-creer="Nouveau type"
    @creer="creation"
  >
    <template #entete>
      <th>Nom</th>
      <th>Tarif journalier</th>
      <th class="d-none d-md-table-cell">Créé le</th>
      <th>Statut</th>
      <th>Actions</th>
    </template>
    <template #ligne="{ ligne: type }">
      <td>{{ type.nom }}</td>
      <td>{{ Number(type.tarifParJour || 0).toLocaleString('fr-FR') }} F CFA</td>
      <td class="d-none d-md-table-cell">{{ formatDate(type.createdAt) }}</td>
      <td>
        <span :class="['badge', type.isEnabled ? 'bg-success' : 'bg-secondary']">{{ type.isEnabled ? 'Activé' : 'Désactivé' }}</span>
      </td>
      <td>
        <div v-if="$store.getters.hasAnyPermission(['CONFIG_MODIFIER_TYPE_CHAMBRE', 'CONFIG_SUPPRESSION_TYPE_CHAMBRE'])" class="dropdown">
          <button class="btn btn-sm btn-outline-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown" v-dropdown-fixed>Actions</button>
          <ul class="dropdown-menu">
            <li v-if="$store.getters.hasPermission('CONFIG_MODIFIER_TYPE_CHAMBRE')"><a class="dropdown-item" href="#" @click.prevent="modifier(type.id)">Modifier</a></li>
            <li v-if="$store.getters.hasPermission('CONFIG_SUPPRESSION_TYPE_CHAMBRE')"><a class="dropdown-item text-danger" href="#" @click.prevent="supprimer(type)">Supprimer</a></li>
          </ul>
        </div>
      </td>
    </template>
  </ListeReferentiel>
</template>

<script>
import dayjs from 'dayjs';
import ListeReferentiel from '@/components/commun/ListeReferentiel.vue';

export default {
  name: 'ListeTypeChambre',
  components: { ListeReferentiel },
  methods: {
    formatDate(date) {
      return date ? dayjs(date).format('DD/MM/YYYY HH:mm') : '—';
    },
    creation() {
      this.$router.push({ name: 'create_type_chambre' });
    },
    modifier(id) {
      this.$router.push({ name: 'edit_type_chambres', params: { id } });
    },
    supprimer(type) {
      this.$refs.liste.supprimer({
        id: type.id,
        titre: 'Supprimer le type de chambre',
        message: `Supprimer le type de chambre « ${type.nom} » ?`,
        succes: 'Type de chambre supprimé.',
      });
    },
  },
};
</script>
